export const challengeTaskUid = 'Challenge';
